import { buildUrl } from '../../../utils/api';

export const fetchOrganizationURL = (id: number) =>
  buildUrl(`/api/v3/adm/organization/${id}`);
